module.exports = __webpack_public_path__ + "img/hat-icon.d4ba2376.svg";